import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/rahreivee/emagyl.ro/app/[[...slug]]/PageContent.js");
